import { render, staticRenderFns } from "./OAuth2.vue?vue&type=template&id=192b21ca&scoped=true"
import script from "./OAuth2.vue?vue&type=script&lang=js"
export * from "./OAuth2.vue?vue&type=script&lang=js"
import style0 from "./OAuth2.vue?vue&type=style&index=0&id=192b21ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192b21ca",
  null
  
)

export default component.exports